export default function LinkArrow(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 27}
      height={height ? height : width ? width : 14.6}
      viewBox="0 0 37 20"
      fill="none"
    >
      <path d="M0 10H34" stroke="currentColor" strokeWidth="3" />
      <path d="M27 2L34.5 10L27 18" stroke="CurrentColor" strokeWidth="3" />
    </svg>
  );
}
